import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '../../atoms';
import { InformationStatsBlock, DescriptionParagraph } from './styles.js';

export const InfoStatBlock = ({ heading, description, backgroundColor }) => {
  return (
    <InformationStatsBlock backgroundColor={backgroundColor}>
      <Heading
        headingLevel="h2"
        typography="heading1"
        headingText={heading}
        position="center"
        backgroundColor="background.dark"
      />
      <DescriptionParagraph>{description}</DescriptionParagraph>
    </InformationStatsBlock>
  );
};

InfoStatBlock.displayName = 'InfoStatBlock';

InfoStatBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
};
